<okeey-cash-slider [slides]="slides"></okeey-cash-slider>
